import { isIOS } from '../../utils';
import './styles.scss';

const createPDFContainer = () => {
  const el = document.createElement('div');
  el.innerHTML = `
    <div class="pdf-container">
      <iframe width="100%" height="100%" frameborder="0"></iframe>
      <button type="button" class="pdf-container__close" aria-label="close popup" title="close popup">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg>
      </button>
    </div>`.trim();

  return el.firstChild;
};

const SamplesPDF = () => {
  if (isIOS) return;

  const PDFcontainer = createPDFContainer();
  const iframe = PDFcontainer.querySelector('iframe');

  document.body.appendChild(PDFcontainer);

  const links = document.querySelectorAll('[data-sample-pdf-link]');

  const hidePDFContainer = () => {
    PDFcontainer.removeEventListener('click', hidePDFContainer);
    PDFcontainer.classList.remove('pdf-container--is-open');
  };

  const showPDFContainer = () => {
    PDFcontainer.classList.add('pdf-container--is-open');
    PDFcontainer.addEventListener('click', hidePDFContainer);
  };

  function handleClick(event) {
    event.preventDefault();

    const pdfLink = this.getAttribute('href');

    if (iframe.getAttribute('src') !== pdfLink)
      iframe.setAttribute('src', this.getAttribute('href'));

    showPDFContainer();
  }

  Array.from(links).forEach(link => link.addEventListener('click', handleClick));
};

document.addEventListener('DOMContentLoaded', SamplesPDF);
